import React from 'react';

import { cn } from '@src/lib/utils';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}
export const Container: React.FC<ContainerProps> = ({ children, className = '' }: ContainerProps) => {
  return (
    <div
      className={cn(
        'h-fit shrink-0 px-3 lg:px-0 w-full lg:w-[700px] flex flex-col justify-center items-center gap-4 lg:gap-8',
        className
      )}
    >
      {children}
    </div>
  );
};
